import { Component, OnInit, Input, SimpleChanges, ViewChild, ElementRef, Compiler } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { UserService } from './../user/services/user.service';
import { Subject, Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { environment } from './../../environments/environment';
import { DatasharingService } from '../suggest-products/services/datasharing.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [UserService]
})
export class HeaderComponent implements OnInit {
  @ViewChild("search") nameField: ElementRef;
  
  searchForm: FormGroup;
  submitted = false;
  searchText= '';
  private searchSubscription: Subscription;
  subscription: Subscription;
  searchTextChanged = new Subject<string>();
  @Input() currentTab;
  enableSearch = true;
  errMessage: any;
  user: any;
  search_clear = false;
  currentComponentName: string;
  sub : any;
  imgPath = environment.profile_s3_path+ '/'+environment.profileFolder
  constructor( private router: Router,
    private userService: UserService,
    private sharedService:DatasharingService,
    private route: ActivatedRoute,
    private _compiler: Compiler,
    public element: ElementRef<HTMLElement>) {
      this.currentComponentName = this.route.routeConfig.component.name;
      
     }
    
    ngAfterViewInit(): void {
      if (this.searchText) {
        setTimeout(() => this.nameField.nativeElement.focus(), 200);
      }

      this.search_clear = (localStorage.getItem('search_clear') =="true");
      if (this.search_clear){
          this.nameField.nativeElement.focus();
      }
      this.sharedService.currentStorage.subscribe(message => this.user=message)
    }
  
    ngOnInit() {
      this.user = JSON.parse((localStorage.getItem('user')));
      this.searchText = localStorage.getItem('search_value');
      this.sharedService.currentStorage.subscribe(message => this.user = message)

      this.searchSubscription = this.searchTextChanged
      .debounceTime(500)
      .subscribe((data) => { this.searchStore(); });

      this.router.events.subscribe(event =>{
        if (event instanceof NavigationStart){
           localStorage.setItem('search_clear', 'false');
        }
     })
    }

    setStorage(image_url){
      this.user = JSON.parse((localStorage.getItem('user')));
    }

    searchRecord(event) {
      if (event.key === "Enter") {
        localStorage.setItem('search_clear', 'false');
        this.searchText = event.target.value.trim();
        if (this.searchText.length > 0){
          this.nameField.nativeElement.focus();
        }
        this.searchTextChanged.next();
      }

     
      
    }

  clearSearch(){
    this.searchText = '';
    this.searchStore();
    localStorage.setItem('search_clear', 'true');
  }


  ngOnChanges(changes: SimpleChanges) {
    this.enableSearch = changes.currentTab.currentValue != null;
    if (!this.enableSearch){
      this.searchText = '';
      localStorage.setItem('search_value', '')
    }
  }

  searchStore() {
    const search_value = this.searchText
    localStorage.setItem('search_value', search_value)
    this.router.navigate(['sales/'+this.currentTab], {state: {search_value: search_value}}); 
  }

  logout() {
    this.userService.logout()
      .subscribe(
        response => {
          localStorage.removeItem('user');
          localStorage.removeItem('is_remember');
          sessionStorage.removeItem('user');
          
          localStorage.clear();
          sessionStorage.clear();
          // window.location.reload()
          this._compiler.clearCache();
          this.router.navigate(['users/login']);
          // window.location.reload(true)
          
        },
        error => { }
      );
  }
}
